<template>
  <div>
    <a-card>
      <h3 class="margin-top-40">导入账期信息</h3>
      <div class="text-right">
        <!-- <a-button
          type="primary"
          class="margin-right-20"
          icon="plus"
          @click="upload"
        >
          上传账期EXCEL
        </a-button> -->

        <!-- 新增批量导入账期modal -->
        <batch-upload-modal
          ref="batchUploadModal"
          btnText="上传账期EXCEL"
          icon="plus"
          modal-title="上传账期EXCEL"
          @ok="handleNewModalOk"
          @download="_downloadTemp"
        />
        <!-- <a-button
          type="primary"
          class="add-btn"
          @click="handleSave"
          :disabled="submitFlag"
        >
          确定导入
        </a-button> -->
      </div>

      <!-- <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
      ></TableView> -->
    </a-card>

    <!-- <a-modal
      v-model="visible"
      destroyOnClose
      @ok="handleSubmit"
      title="上传专项额度EXCEL"
      :maskClosable="false"
    >
      <a-form :form="modalForm" :labelCol="{ span: 4 }">
        <a-form-item label="模板下载">
          <a-button type="link" @click="handleTemplateDownload">
            点击下载
          </a-button>
        </a-form-item>
        <a-form-item label="附件上传">
          <a-upload
            :beforeUpload="handleBeforeUpload"
            :fileList="fileList"
            :remove="handleRemove"
            @change="onChange"
          >
            <a-button>
              <a-icon type="upload" />
              选取文件
            </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
    </a-modal> -->

    <div class="text-left" style="margin-top: 20px">
      <a-button
        type="primary"
        class="add-btn"
        @click="progress"
        :disabled="this.optionStatus == 1"
      >
        同步集团关系
      </a-button>
    </div>

    <div v-if="this.type == 1">
      <div class="process-border">
        <span style="position: absolute; font-size: 12px">
          {{ processsWidth }}
        </span>
        <div class="process-content" :style="{ width: processsWidth }"></div>
      </div>
      <div class="process-message">{{ message }}</div>
    </div>

    <div class="text-left" style="margin-top: 20px">
      <a-button
        type="primary"
        class="add-btn"
        @click="progress2"
        :disabled="this.termStatus == 1"
      >
        同步客户账期
      </a-button>
    </div>

    <div v-if="this.type2 == 2">
      <div class="process-border">
        <span style="position: absolute; font-size: 12px">
          {{ processsWidth1 }}
        </span>
        <div class="process-content" :style="{ width: processsWidth1 }"></div>
      </div>
      <div class="process-message">{{ message1 }}</div>
    </div>

    <div class="text-left" style="margin-top: 20px">
      <a-button
        type="primary"
        class="add-btn"
        @click="progress3"
        :disabled="this.limitStatus == 1"
      >
        同步通用额度
      </a-button>

      <a-button
        type="link"
        size="small"
        @click="handleDownload()"
        v-if="this.limitStatus == 1"
      >
        下载
      </a-button>
    </div>

    <div v-if="this.type3 == 3">
      <div class="process-border">
        <span style="position: absolute; font-size: 12px">
          {{ processsWidth2 }}
        </span>
        <div class="process-content" :style="{ width: processsWidth2 }"></div>
      </div>
      <div class="process-message">{{ message2 }}</div>
    </div>

    <div class="text-left" style="margin-top: 20px">
      <batch-upload-modal
        ref="batchUploadModal"
        btnText="同步专项额度"
        modal-title="同步专项额度"
        @ok="handleSubSpecialOk"
        @download="_downloadSpecialTemp"
        :specialStatus="this.specialStatus"
      />
    </div>
  </div>
</template>

<script>
// import { TableView } from 'lxfintech-fe'
import mixin from './mixin'
import {
  saveTerm,
  // templateDownload,
  readFile,
  syncGroup,
  syncPayment,
  syncCurrent,
  syncSpecial,
  getSyncStatus,
  getTermStatus,
  getCurrentStatus,
  getSpecialStatus,
  downloadTemp,
  uploadBatchFile,
  downloadSpecialTemp,
  uploadBatchSpecialFile,
  download,
} from './api'
import XLSX from 'xlsx'
import { message } from 'ant-design-vue'
import BatchUploadModal from 'components/BatchUploadModal.vue'
const typeList = [
  {
    value: 1,
    label: 'S4',
  },
  {
    value: 2,
    label: 'ECC',
  },
]
export default {
  mixins: [mixin],
  data() {
    return {
      fileList: [],
      dataList: [],
      submitFlag: false,
      dataSource: [],
      type: '',
      type2: '',
      type3: '',
      type4: '',

      processsWidth: '0%',
      timer: {},
      currentStatus: 1,
      message: undefined,

      processsWidth1: '0%',
      timer1: {},
      currentStatus1: 1,
      message1: undefined,

      processsWidth2: '0%',
      timer2: {},
      currentStatus2: 1,
      message2: undefined,

      processsWidth3: '0%',
      timer3: {},
      currentStatus3: 1,
      message3: undefined,

      typeStatus: 1,
      typeStatus2: 2,
      typeStatus3: 3,
      typeStatus4: 4,

      optionStatus: '',
      termStatus: '',
      limitStatus: '',
      specialStatus: '',

      searchCardLoading: true,
      visible: false,
      modalForm: this.$form.createForm(this),
      modalTitle: '新增',
      typeList,
      businessList: [],
    }
  },
  components: {
    // TableView,
    BatchUploadModal,
  },
  mounted() {
    this.selectSyncStatus()
    this.selectTermStatus()
    this.selectCurrentStatus()
    this.selectSpecialStatus()
  },
  methods: {
    // 进度条根据完成度自定义分段的颜色 -- 参数successPercent表示已完成的分段百分比
    getProgressColor(successPercent) {
      let color = ''
      if (successPercent <= 50) {
        color = '#1486b4'
      } else if (successPercent > 50 && successPercent < 90) {
        color = '#ffb700'
      } else if (successPercent >= 90) {
        color = '#cb0909'
      }
      return color
    },

    // upload() {
    //   this.visible = true
    //   this.fileList = []
    // },
    // // 模板下载
    // handleTemplateDownload() {
    //   this.modalForm.validateFields(async err => {
    //     if (!err) {
    //       try {
    //         await templateDownload(21)    //21专项额度模板编号
    //       } catch (e) {
    //         // No processing
    //       }
    //     }
    //   })
    // },
    // // 上传之前
    // handleBeforeUpload(file) {
    //   this.fileList = [...this.fileList, file]
    //   this.fileList = this.fileList.slice(-1)
    //   return false
    // },
    // // 删除上传文件
    // handleRemove(file) {
    //   const index = this.fileList.findIndex(item => item.uid === file.uid)
    //   this.remove(index)
    // },
    // // 本地删除
    // remove(index) {
    //   const newFileList = this.fileList.slice()
    //   newFileList.splice(index, 1)
    //   this.fileList = newFileList
    // },

    // // 提交
    // async handleSubmit(fileList) {
    //   debugger
    //    if (fileList && fileList.length) {
    //     try {
    //       await uploadBatchFile({ file: fileList })
    //       // this.handleNewModalCancel()
    //        this.visible = false
    //     } catch (error) {
    //       console.error(error)
    //     }
    //   } else {
    //     this.$notification.warning({
    //       message: '提示',
    //       description: '请上传文件',
    //     })
    //   }
    // },

    async onChange(file) {
      const fileRow = file.file
      let dataBinary = await readFile(fileRow, this)
      let workBook = XLSX.read(dataBinary, { type: 'binary', cellDates: true })
      let workSheet = workBook.Sheets[workBook.SheetNames[0]]
      const data = XLSX.utils.sheet_to_json(workSheet)

      this.dataList = this.getNormalBom(data)
    },

    getNormalBom(data) {
      const dataList = data.map(item => {
        return {
          // bomId: uuidv1().replaceAll("-", ""),
          segment: item.Segment || '',
          name: item.客户名称 || '',
          code: item.客户编码 || '',
          term: item.账期 || '',
          bgName: item.业务类型 || '',
        }
      })
      dataList.forEach(element => {
        if (!element.code) {
          element.error = '客户编号缺失'
          this.submitFlag = true
        }
        if (!element.bgName) {
          element.error = '业务类型缺失'
          this.submitFlag = true
        }
        if (!element.segment) {
          element.error = 'Segmentlevel缺失'
          this.submitFlag = true
        }
      })
      return dataList
    },

    // 确定导入
    handleSave() {
      if (this.tableData.length > 0) {
        this.$confirm({
          title: '提示',
          content: `是否确认导入客户账期信息?`,
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
            console.log(this.tableData)
            const a = {
              companySegmentTermBO: this.tableData,
            }
            saveTerm(a)
          },
          onCancel: () => {
            this.$message.info('已取消提交')
          },
        })
      } else {
        return message.error('导入数据不能为空！')
      }
    },

    // 下载模板
    _downloadTemp() {
      downloadTemp()
    },
    // 确认上传批量导入账期
    async handleNewModalOk(fileList) {
      if (fileList && fileList.length) {
        try {
          await uploadBatchFile({ file: fileList })
          this.handleNewModalCancel()
        } catch (error) {
          console.error(error)
        }
      } else {
        this.$notification.warning({
          message: '提示',
          description: '请上传文件',
        })
      }
    },

    handleNewModalCancel() {
      this.$refs.batchUploadModal.handleCancel()
    },

    //专项额度
    // 下载模板
    _downloadSpecialTemp() {
      downloadSpecialTemp()
    },
    // 确认上传批量导入专项额度
    async handleSubSpecialOk(fileList) {
      if (fileList && fileList.length) {
        try {
          await uploadBatchSpecialFile({ file: fileList })
          this.handleSubSpecialCancel()
          this.selectSpecialStatus()
          this.$message.success('同步成功')
        } catch (error) {
          console.error(error)
          //   this.$notification.error({
          //   message: '警告',
          //   duration: 0,
          //   description: error,
          //  })
        }
      } else {
        this.$notification.warning({
          message: '提示',
          description: '请上传文件',
        })
      }
    },

    handleSubSpecialCancel() {
      this.$refs.batchUploadModal.handleCancel()
    },

    //查看同步集团关系按钮是否已经初始化过
    selectSyncStatus() {
      getSyncStatus(this.typeStatus).then(repsonse => {
        this.optionStatus = repsonse.data
      })
    },
    //查看同步客户账期按钮是否已经初始化过
    selectTermStatus() {
      getTermStatus(this.typeStatus2).then(repsonse => {
        this.termStatus = repsonse.data
      })
    },
    //查看同步通用额度按钮是否已经初始化过
    selectCurrentStatus() {
      getCurrentStatus(this.typeStatus3).then(repsonse => {
        this.limitStatus = repsonse.data
      })
    },
    //查看同步专项额度按钮是否已经初始化过
    selectSpecialStatus() {
      getSpecialStatus(this.typeStatus4).then(repsonse => {
        this.specialStatus = repsonse.data
      })
    },

    //同步集团关系
    progress() {
      const _this = this
      this.$confirm({
        title: '提示',
        content: `是否确认同步集团关系? 只允许同步一次!`,
        okText: '确认',
        cancelText: '取消',
        type: 'warning',
        onOk: () => {
          _this.processsWidth = '0%'
          _this.currentStatus = 1
          _this.timer = setInterval(() => {
            _this.syncList()
          }, 1000)
          this.type = 1
        },
        onCancel: () => {
          _this.$message.success('已取消同步')
        },
      })
    },

    syncList() {
      syncGroup(this.currentStatus).then(repsonse => {
        const result = JSON.parse(repsonse.data)
        this.processsWidth = result.result.toFixed(2) + '%'
        this.message = result.msg
        if (result.result == 100.0 || result.msg == '集团关系同步失败') {
          setTimeout(() => {
            clearInterval(this.timer)
          }, 0)
          this.selectSyncStatus()
        }
      })
      this.currentStatus = 2
    },

    //同步客户账期
    progress2() {
      const _this = this
      this.$confirm({
        title: '提示',
        content: `是否确认同步客户账期? 只允许同步一次!`,
        okText: '确认',
        cancelText: '取消',
        type: 'warning',
        onOk: () => {
          _this.processsWidth1 = '0%'
          _this.currentStatus1 = 1
          _this.timer1 = setInterval(() => {
            _this.syncList1()
          }, 1000)
          this.type2 = 2
        },
        onCancel: () => {
          _this.$message.success('已取消同步')
        },
      })
    },

    syncList1() {
      syncPayment(this.currentStatus1).then(repsonse => {
        const result = JSON.parse(repsonse.data)
        this.processsWidth1 = result.result.toFixed(2) + '%'
        this.message1 = result.msg
        if (result.result == 100.0 || result.msg == '客户账期同步失败') {
          setTimeout(() => {
            clearInterval(this.timer1)
          }, 0)
          this.selectTermStatus()
        }
      })
      this.currentStatus1 = 2
    },

    //同步通用额度
    progress3() {
      const _this = this
      this.$confirm({
        title: '提示',
        content: `是否确认同步通用额度? 只允许同步一次!`,
        okText: '确认',
        cancelText: '取消',
        type: 'warning',
        onOk: () => {
          _this.processsWidth2 = '0%'
          _this.currentStatus2 = 1
          _this.timer2 = setInterval(() => {
            _this.syncList2()
          }, 1000)
          this.type3 = 3
        },
        onCancel: () => {
          _this.$message.success('已取消同步')
        },
      })
    },

    syncList2() {
      syncCurrent(this.currentStatus2).then(repsonse => {
        const result = JSON.parse(repsonse.data)
        this.processsWidth2 = result.result.toFixed(2) + '%'
        this.message2 = result.msg
        if (result.result == 100.0 || result.msg == '通用额度同步失败') {
          setTimeout(() => {
            clearInterval(this.timer2)
          }, 0)
          // this.selectCurrentStatus()
        }
      })
      this.currentStatus2 = 2
      this.selectCurrentStatus()
    },

    //同步专项额度
    progress41() {
      const _this = this
      this.$confirm({
        title: '提示',
        content: `是否确认同步专项额度? 只允许同步一次!`,
        okText: '确认',
        cancelText: '取消',
        type: 'warning',
        onOk: () => {
          _this.processsWidth3 = '0%'
          _this.currentStatus3 = 1
          _this.timer3 = setInterval(() => {
            _this.syncList3()
          }, 1000)
          this.type4 = 4
        },
        onCancel: () => {
          _this.$message.success('已取消同步')
        },
      })
    },

    syncList3() {
      syncSpecial(this.currentStatus3).then(repsonse => {
        const result = JSON.parse(repsonse.data)
        this.processsWidth3 = result.result.toFixed(2) + '%'
        this.message3 = result.msg
        if (result.result == 100.0) {
          this.selectSpecialStatus()
          setTimeout(() => {
            clearInterval(this.timer3)
          }, 0)
        }
      })
      this.currentStatus3 = 2
    },

    // 下载
    handleDownload() {
      download()
    },
  },
}
</script>

<style>
.process-border {
  width: 800px;
  height: 23px;
  border-radius: 15px;
  border: 2px solid #50dfef;
  padding: 1px;
  text-align: center;
  line-height: 23px;
  position: relative;
}
.process-content {
  height: 19px;
  border-radius: 15px;
  background: #00c1de;
}
.process-message {
  font-size: 13px;
  margin-top: 5px;
}
</style>
